
import { Tabs } from "antd";
// import LeavePaidTimeOff from "./tabs/LeavePaidTimeOff";
import LeavePaidGenerate from "./tabs/LeavePaidgenerate";
import LeavePaidTimeOffNew from "./tabs/LeavePaidTimeOffNew";
const { TabPane } = Tabs;

export default function LeavePaid() {
  return (
    <div>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Time Off" key="1">
          <LeavePaidTimeOffNew />
        </TabPane>
        <TabPane tab="Time Off Generate" key="2">
          <LeavePaidGenerate />
        </TabPane>
      </Tabs>
    </div>
  );
}
